//
import WhProductDeletedModel from '@/models/Warehouse/WhProductDeleted'

/**
 * 
 */
export default class WhProductDeleted {

  /**
   * 
   */
  static restore(whProductDeleted) {
    return whProductDeleted.restore().attach()
  }

  /**
   * 
   */
  static model() {
    return WhProductDeletedModel
  }

  /**
   * 
   */
  static toList() {
    return class extends WhProductDeletedModel {
      static includes = [
        // 'g_user.hr_employee',
        // 'pos_cash_desk.g_branch_office',
        // 'sl_customer',
      ]
    }
  }
}